import React, { useState } from 'react'
import Dashboardnavbarcopy from '../../layout/Dashboardnavbarcopy';
import PortalSetup from './PortalSetup';
import GeneralSettings from './PortalSettings/PortalSettingsDisplay';
import { ImprestFormatTable, ProcessApprovalFlowSettings } from './PortalSettings/PortalSettingsTables';


const SettingsManagementDisplay = () => {

    const [toggleState, setToggleState] = useState(1);


    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'General Settings';
            case 2:
                return 'Portal Setup';
            default:
                return 'Setting';
        }
    };


    return (
        <>
            <div>
                <Dashboardnavbarcopy name={getSelectedTitle()} url="Settings" />
                <div className="bloc-tabss  wfm-margin">
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(1)}
                    >
                        General Settings
                    </button>
                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(2)}
                    >
                        Portal Setup
                    </button>


                </div>

                <div className="">

                    {toggleState === 1 ? <GeneralSettings /> : null}

                    {toggleState === 2 ? <PortalSetup /> : null}


                </div>
            </div>

        </>
    )
}

export default SettingsManagementDisplay
